module.exports = __webpack_public_path__ + "img/planta_12.af709eae.png";